import { Component, Input, ViewChild, OnInit, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SharedAuthService } from '../../../../../../shared/shared.auth.service';
import { MaintenanceService } from '../../../../../../techopsv4/services/maintenanceService';
import { MatTabGroup, MatTab, MatTabLabel, MatTabContent } from '@angular/material/tabs';
import { NgIf } from '@angular/common';
import { PropTableComponent } from '../../prop-table/prop-table.component';

@Component({
    selector: 'app-my-prop-requests',
    templateUrl: './my-prop-requests.component.html',
    styleUrl: './my-prop-requests.component.css',
    imports: [MatTabGroup, MatTab, MatTabLabel, NgIf, MatTabContent, PropTableComponent]
})
export class MyPropRequestsComponent implements OnChanges, OnInit {
  selectedIndex: any = 0;
  authorMsid: string = '';
  dataSource: any={};
  cancelledDataSource: any[];
  rejectedDataSource: any[];
  openRequestsCount: string = '';
  cancelledRequestsCount: string = '';
  rejectedRequestsCount: string = '';
  completedRequestsCount: string = '';
  receivedData:boolean = true;
  openColumns = [
    {
      columnDef: 'Request_Id',
      header: 'Proposal ID',
      link: true,
      filter: true,
      isSort: true,
      width: '14% !important'
    },
    {
      columnDef: 'Funding_UCMG',
      header: 'Investment Name - UCMG ID',
      displayText: 'Funding_UCMG',
      link: false,
      filter: true,
      isSort: true,
      width: '30% !important'
    },
    {
      columnDef: 'Req_Status',
      header: 'Status',
      displayText: 'Req_Status',
      isSort: false,
      filter: false,
      width: '19% !important'
    },
    {
      columnDef: 'created_at',
      header: 'Requested On',
      displayText: 'created_at',
      isSort: true,
      filter: false,
      width: '17% !important'
    },
    {
      columnDef: 'Action',
      header: 'Action',
      button: true,
      filter: false,
      isSort: false,
      padding: "0 1% 0 0",
      width: '14% !important'
    },
    {
      columnDef: 'Hierarchy',
      header: 'Hierarchy',
      filter: false,
      isSort: false,
      textAlign: 'center',
      width: '6% !important'
    },
    {
      columnDef: 'reset_filter',
      header: ``,
      width: '1% !important',
      textAlign: 'center',
      cell: ``,
    }

  ];

  completedColumns = [
    {
      columnDef: 'Request_Id',
      header: 'Proposal ID',
      link: true,
      filter: true,
      width: "14%",
      isSort: true,
    },
    {
      columnDef: 'Funding_UCMG',
      header: 'Investment Name - UCMG ID',
      displayText: 'Funding_UCMG',
      filter: true,
      width: '30% !important',
      padding: "0 1% 0 0",
      isSort: true,
    },
    {
      columnDef: 'created_at',
      header: 'Requested On',
      displayText: 'created_at',
      width: '17% !important',
      isSort: true,
    },
    {
      columnDef: 'completed_by',
      header: 'Addressed By',
      displayText: 'updated_by',  
      width: '19% !important',
      filter: true,
      isSort: true,
    },
    {
      columnDef: 'completed_at',
      header: 'Addressed On',
      displayText: 'updated_at',
      lastColumn: true,
      width: '15% !important',
      isSort: true,
    },
    {
      columnDef: 'Hierarchy',
      header: 'Hierarchy',
      filter: false,
      isSort: false,
      textAlign: 'center',
      width: '6% !important'
    },
    {
      columnDef: 'reset_filter',
      header: ``,
      width: '2% !important',
      textAlign: 'center',
      cell: ``,
    }
  ];

  rejectedColumns = [
    {
      columnDef: 'Request_Id',
      header: 'Proposal ID',
      link: true,
      filter: true,
      width: "14%",
      isSort: true,
    },
    {
      columnDef: 'Funding_UCMG',
      header: 'Investment Name - UCMG ID',
      displayText: 'Funding_UCMG',
      filter: true,
      width: '30% !important',
      padding: "0 1% 0 0",
      isSort: true,
    },
    {
      columnDef: 'created_at',
      header: 'Requested On',
      displayText: 'created_at',
      width: '17% !important',
      isSort: true,
    },
    {
      columnDef: 'rejected_by',
      header: 'Addressed By',
      displayText: 'updated_by',  
      width: '19% !important',
      filter: true,
      isSort: true,
    },
    {
      columnDef: 'rejected_at',
      header: 'Addressed On',
      displayText: 'updated_at',
      lastColumn: true,
      width: '15% !important',
      isSort: true,
    },
    {
      columnDef: 'Hierarchy',
      header: 'Hierarchy',
      filter: false,
      isSort: false,
      textAlign: 'center',
      width: '6% !important'
    },
    {
      columnDef: 'reset_filter',
      header: ``,
      width: '2% !important',
      textAlign: 'center',
      cell: ``,
    }
  ];

  cancelledColumns = [
    {
      columnDef: 'Request_Id',
      header: 'Proposal ID',
      link: true,
      filter: true,
      width: "12%",
      isSort: true,
    },
    {
      columnDef: 'Funding_UCMG',
      header: 'Investment Name - UCMG ID',
      displayText: 'Funding_UCMG',
      filter: true,
      width: '30% !important',
      isSort: true,
    },
    {
      columnDef: 'created_at',
      header: 'Requested On',
      displayText: 'created_at',
      width: '17% !important',
      isSort: true,
    },
    {
      columnDef: 'updated_by',
      header: 'Cancelled By',
      width: '17% !important',
      displayText: 'updated_by',
      filter: true,
      isSort: true,
    },
    {
      columnDef: 'updated_at',
      header: 'Cancelled On',
      displayText: 'updated_at',
      lastColumn: true,
      width: '17% !important',
      isSort: true,
    },
    {
      columnDef: 'Hierarchy',
      header: 'Hierarchy',
      filter: false,
      isSort: false,
      textAlign: 'center',
      width: '6% !important'
    },
    {
      columnDef: 'reset_filter',
      header: ``,
      width: '2% !important',
      textAlign: 'center',
      cell: ``,
    } ];

    fromWorkQueue = false;
    @ViewChild('createNewRequestPopup') createNewRequestPopup;
    @Input() propRequestTypeDetailsForCreate: any;
    countData: any;
    formatteddata: any;
    @ViewChild('requestDetailsPopup') requestDetailsPopup;
    openRequestId: any;
    fromMyRequestsCreateNew: boolean;
    restrictUserAccess: boolean = false;
    reloadOpenRequests: boolean;
    @Input() propRequestIdsForView = [];
    @Input() propRequestCreateRoles = [];
    requestStatus = '';
    tableDataSource: any[] = [];
  
    constructor(
      public toaster: ToastrService,
      public maintenanceService: MaintenanceService,
      public sharedAuthService: SharedAuthService) {
    }
    ngOnInit() {
      this.getRequestDetails();
 
    }

    ngOnChanges() {
      if (this.propRequestIdsForView && this.propRequestIdsForView.length > 0) {
        this.tableDataSource = this.dataSource['Open'].filter(request =>
          this.propRequestIdsForView.includes(request.Request_Id)
        );
      }
    }


  onMatChange(_event, selectedIndex) {
    let status = 'Open';
    if (selectedIndex === 0) {
        status = 'Open';
        this.tableDataSource = this.dataSource[status];
    } else if (selectedIndex === 1) {
        status = 'Approved';
        this.tableDataSource = this.dataSource[status];
    } else if (selectedIndex === 2) {
        status = 'Rejected';
        this.tableDataSource = this.dataSource[status];
    } else if (selectedIndex === 3) {
        status = 'Cancelled';
        this.tableDataSource = this.dataSource[status];
    }
}

getRequestDetails() {
  this.maintenanceService.getMyPropRequestData().subscribe((response: any) => {
    this.dataSource = response;
    this.dataSource['Open'] = this.dataSource['Open'] || [];
    this.dataSource['Approved'] = this.dataSource['Approved'] || [];
    this.dataSource['Cancelled'] = this.dataSource['Cancelled'] || [];
    this.dataSource['Rejected'] = this.dataSource['Rejected'] || [];

    // Reorder 'Open' data
    this.dataSource['Open'].sort((a, b) => {
        const aPriority = a.Req_Status === 'Open' && a.Approver_Justification1 !== null ? 1 : 0;
        const bPriority = b.Req_Status === 'Open' && b.Approver_Justification1 !== null ? 1 : 0;
        return bPriority - aPriority;
    });

    this.receivedData = true;
    this.tableDataSource = this.dataSource['Open'];
    this.openRequestsCount = this.dataSource['Open'].length.toString();
    this.cancelledRequestsCount = this.dataSource['Cancelled'].length.toString();
    this.rejectedRequestsCount = this.dataSource['Rejected'].length.toString();
    this.completedRequestsCount = this.dataSource['Approved'].length.toString();
    

  }, (_error: any) => {
    console.error('Error fetching request data:', _error);
    this.toaster.error('Error fetching request data', '', { timeOut: 5000, positionClass: 'toast-top-center' });
    this.receivedData = true;
  });
}

reloadData(){

  this.getRequestDetails();
  
}

updateTableContent(status: string) {
  if (this.dataSource[status]) {
    this.tableDataSource = this.dataSource[status];
  } else {
    this.tableDataSource = [];
  }
}

}
